import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

// Config
import { Config } from '../../providers/config/config';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=UTF-8;'
  })
}

@Injectable()
export class UsersService {
  data: any;

  constructor( 
    public http: HttpClient
  ) {
  }

  saveUser( user )
  {
    user.client_id = Config.APP_CLIENT_ID;
    user.grant_type = 'password';
    user.base_gate = Config.APP_BASE_GATE;

    if ( user.user_id > 0 )
    {
      // Edit user 
      return this.http.put( Config.API_ROOT_CORE + 'users/' + user.user_id, JSON.stringify(user), httpOptions );
    } else {
      return this.http.post( Config.API_ROOT_CORE + 'register', JSON.stringify(user), httpOptions );
    } 
  }

  getUsers()
  {
    return this.http.get( Config.API_ROOT_CORE + 'users?app_base_gate=' + Config.APP_BASE_GATE )
      .pipe( map( this.processData, this ));
  }

  removeUserFromApp( userId )
  {
    let user:any = {};
    user.user_id = userId;
    user.app_base_gate = Config.APP_BASE_GATE;

    return this.http.post( Config.API_ROOT_CORE + 'remove-user-from-app', JSON.stringify(user), httpOptions );
  }

  processData(data: any) 
  {
    this.data = data;

    return this.data;
  } 
}  


// WEBPACK FOOTER //
// ./src/providers/users/users-service.ts